import React, { useState, useEffect } from "react";
import { withRouter } from 'react-router-dom';
import { Form, Button, DatePicker, Table } from 'antd';
import './environmentalMonitoring.less'
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import { formatTime } from '@/utils/util.js'
import * as echarts from 'echarts';

import MonitoringDetails from '../MonitoringDetails/monitoringDetails'
import MonitoringDetailsDay from '../MonitoringDetailsDay/MonitoringDetailsDay';

const chartXData = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].filter(item => {
  return parseInt(item) <= new Date().getHours()
})


function EnvironmentalMonitoring() {
  const projectId = React.$getStorage('projectInfo').id
  const [searchForm] = Form.useForm();
  const { RangePicker } = DatePicker;
  const [deviceList, setDeviceList] = useState([]);
  const [navActiveIndex, setNavActiveIndex] = useState(null);
  const [areaActiveIndex, setAreaActiveIndex] = useState(0);
  const [monitorDetail, setMonitorDetail] = useState({});
  const [tableList, setTableList] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 3,
    total: 0
  })
  const columns = [
    {
      title: '序号',
      align: 'center',
      render: (text, record, index) => {
        return <span>{index + 1}</span>
      }
    },
    {
      title: '预警指标',
      dataIndex: 'type',
      align: 'center',
      render: (text, record, index) => {
        let typeText = ""
        switch (record.type) {
          case 2:
            typeText = 'pm10'
            break
          case 3:
            typeText = 'pm2.5'
            break
          case 4:
            typeText = '噪声'
            break
          case 5:
            typeText = '温度'
            break
          case 6:
            typeText = '湿度'
            break
          case 7:
            typeText = '风力'
            break
          case 8:
            typeText = '风速'
            break
          case 9:
            typeText = '风向（方位）'
            break
          case 10:
            typeText = '风向（度数）'
            break
          case 11:
            typeText = 'TSP'
            break
          case 12:
            typeText = '气压'
            break
        }
        return <span>{typeText}</span>
      }
    },
    {
      title: '预警等级',
      dataIndex: 'nameStation',
      align: 'center',
      render: (text, record, index) => {
        let typeText = ""
        switch (record.grade) {
          case 2:
            typeText = '蓝色预警'
            break
        }
        return <span>{typeText}</span>
      }
    },
    {
      title: '预警值',
      dataIndex: 'value',
      align: 'center',
    },
    {
      title: '开始时间',
      dataIndex: 'startingTime',
      align: 'center',
      render: (text, record, index) => {
        return <span>{formatTime(new Date(record.startingTime * 1000), "yyyy-MM-dd hh:mm:ss")}</span>
      }
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      align: 'center',
      render: (text, record, index) => {
        return <span>{formatTime(new Date(record.endTime * 1000), "yyyy-MM-dd hh:mm:ss")}</span>
      }
    }
  ];
  const [chartData, setChartData] = useState([])
  const [childBtn, setchildBtn] = useState([]);
  
  useEffect(() => {
    let childBtn = React.$getStorage('menuchildBtn');
    for(let i = 0; i < childBtn.length; i++) {
      if(childBtn[i].show) {
        let item = childBtn[i];
        toSelecteNav(item.index);
        break;
      }
    }

    setchildBtn(childBtn)
    getMonitoringDeviceAll();
  }, []);

  useEffect(() => {
    getNewestOneMonitoring();
    getTablelList(true);
    getChartData();
  }, [deviceList, areaActiveIndex]);

  useEffect(() => {
    if (monitorDetail && navActiveIndex === 0) {
      drawRingChart1();
      drawRingChart2();
      drawRingChart3();
    }
  }, [monitorDetail]);

  useEffect(() => {
    if (chartData.length && navActiveIndex === 0) {
      drawAirQualityChart();
      drawNoiseChart();
    }
  }, [chartData]);

  useEffect(() => {
    getTablelList();
  }, [pagination])

  const onPaginationChange = (page) => {
    console.log(page)
    setPagination(page)
  }

  const toSelecteNav = (index) => {
    console.log(index);
    setNavActiveIndex(index)
  };

  const toSelecteArea = (index) => {
    setAreaActiveIndex(index)
  };

  const getMonitoringDeviceAll = () => {
    React.$axios.post("monitoringDeviceAll").then(({ data }) => {
      setDeviceList(data.monitoringDeviceAll)
    })
  };

  const getNewestOneMonitoring = () => {
    if (deviceList.length) {
      let devAddr = deviceList[areaActiveIndex].devAddr;

      React.$axios.post("newestOneMonitoring", { devAddr: devAddr })
        .then(({ data }) => {
          setMonitorDetail(data.newestOneMonitoring);
        });
    }
  }

  const getTablelList = (type = false) => {
    if (deviceList.length) {
      const { time } = searchForm.getFieldsValue()
      const startingTime = time ? parseInt(new Date(time[0]._d).getTime() / 1000) : ""
      const endTime = time ? parseInt(new Date(time[1]._d).getTime() / 1000) : ""
      // console.log(time)
      const requestData = {
        projectId: projectId,
        logic: 2,
        offsetLimit: (pagination.current - 1) * pagination.pageSize,
        lengthLimit: pagination.pageSize,
        devAddr: deviceList[areaActiveIndex].devAddr,
        startingTime: startingTime,
        endTime: endTime
      }
      setLoading(true)
      React.$axios.post("listEnvironmentalMonitoringAlarm ", requestData)
        .then(({ data }) => {
          setTableList(data.list)
          if (type) {
            setPagination({
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: data.countList
            })
          }
        }).finally(() => {
          setLoading(false)
        })
    }
  }

  const getChartData = () => {
    if (deviceList.length) {
      const requestData = {
        projectId: projectId,
        logic: 3,
        devAddr: deviceList[areaActiveIndex].devAddr,
        time: parseInt(new Date(new Date().toLocaleDateString()).getTime() / 1000),
        type: [2, 3, 4]
      }
      React.$axios.post("listEnvironmentalMonitoringH ", requestData)
        .then(({ data }) => {
          setChartData(data.list)
        })
    }
  }

  const drawRingChart1 = () => {
    let ringChart1 = echarts.init(
      document.getElementById("ringChart1")
    );
    ringChart1.setOption({
      // color: [getColor(monitorDetail.pm2_5), "#394576"],
      color: ["#389af4", "#ddd"],
      series: [
        {
          name: "",
          type: "pie",
          radius: ["70%", "83%"],
          avoidLabelOverlap: false,
          // legendHoverLink: false,
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: monitorDetail.pm2_5, name: "" },
            { value: 500 - parseInt(monitorDetail.pm2_5), name: "" },
          ],
        },
      ],
    });
  }
  const drawRingChart2 = () => {
    let ringChart2 = echarts.init(
      document.getElementById("ringChart2")
    );
    ringChart2.setOption({
      // color: [getColor(monitorDetail.pm10), "#394576"],
      color: ["#23ca96", "#ddd"],
      series: [
        {
          name: "",
          type: "pie",
          radius: ["70%", "83%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: monitorDetail.pm10, name: "" },
            { value: 500 - parseInt(monitorDetail.pm10), name: "" },
          ],
        },
      ],
    });
  }
  const drawRingChart3 = () => {
    let ringChart3 = echarts.init(
      document.getElementById("ringChart3")
    );
    ringChart3.setOption({
      // color: [getColor(monitorDetail.noiseDb), "#394576"],
      color: ["#ffc257", "#ddd"],
      series: [
        {
          name: "",
          type: "pie",
          radius: ["70%", "83%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: monitorDetail.noiseDb, name: "" },
            { value: 500 - parseInt(monitorDetail.noiseDb), name: "" },
          ],
        },
      ],
    });
  }

  const drawAirQualityChart = () => {
    let airQualityChart = echarts.init(
      document.getElementById("air-quality-chart")
    );
    airQualityChart.setOption({
      color: ['#3aa1ff', '#23ca96'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        right: '30px',
        icon: 'circle',
        data: ['PM2.5', 'PM10']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: chartXData
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: 'PM2.5',
          type: 'line',
          stack: '总量',
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: JSON.parse(chartData.filter(item => item.type === 2)[0].data),
          // data: [],
          areaStyle: {
            color: '#b5f6fc'
          },
          markLine: {
            symbol: 'none',
            data: [{
              lineStyle: {
                type: "dotted",
                color: "#ff8787",
                width: 3
              },
              label: {
                formatter: 'PM2.5(75ug/m3)',
                position: 'middle'
              },
              yAxis: 75
            }]
          }
        },
        {
          name: 'PM10',
          type: 'line',
          stack: '总量',
          smooth: true,
          emphasis: {
            focus: 'series'
          },
          data: JSON.parse(chartData.filter(item => item.type === 3)[0].data),
          // data: [],
          areaStyle: {
            color: '#b5f6fc'
          },
          markLine: {
            symbol: 'none',
            data: [{
              lineStyle: {
                type: "dotted",
                color: "#ff8787",
                width: 3
              },
              label: {
                formatter: 'PM10(150ug/m3)',
                position: 'middle'
              },
              yAxis: 150
            }]
          }
        }
      ]
    });
  }
  const drawNoiseChart = () => {
    let noiseChart = echarts.init(
      document.getElementById("noise-chart")
    );
    noiseChart.setOption({
      color: ['#ffc257'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        right: '30px',
        icon: 'circle',
        data: ['噪音']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: chartXData
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: '噪音',
          type: 'line',
          stack: '总量',
          smooth: true,
          areaStyle: {
            color: '#fff9b8'
          },
          emphasis: {
            focus: 'series'
          },
          data: JSON.parse(chartData.filter(item => item.type === 4)[0].data),
          // data: [],
          markLine: {
            symbol: 'none',
            data: [{
              lineStyle: {
                type: "dotted",
                color: "#ff8787",
                width: 3
              },
              label: {
                formatter: '夜间（55db）',
                position: 'middle'
              },
              yAxis: 55
            }, {
              lineStyle: {
                type: "dotted",
                color: "#ff8787",
                width: 3
              },
              label: {
                formatter: '白天（70db）',
                position: 'middle'
              },
              yAxis: 70
            }]
          }
        }
      ]
    });
  }
  return (
    <div className="environmentalMonitoring">
      <div className="nav-wrap">
        <ul className="nav-list">
          {
            childBtn.map((item,index) => {
              if(item.show) {
                return (
                  <li key={index} className={navActiveIndex === item.index ? 'active' : ''} onClick={() => { toSelecteNav(item.index) }}>{item.name}</li>
                )
              }
            })
          }

          {/* <li className={navActiveIndex === 0 ? 'active' : ''} onClick={() => { toSelecteNav(0) }}>监测概览</li>
          <li className={navActiveIndex === 1 ? 'active' : ''} onClick={() => { toSelecteNav(1) }}>监测明细</li>
          <li className={navActiveIndex === 2 ? 'active' : ''} onClick={() => { toSelecteNav(2) }}>监测数据</li> */}
        </ul>
        <ul className="nav-list">
          {
            deviceList.map(((item, index) => {
              return <li className={areaActiveIndex === index ? 'active' : ''} key={index} onClick={() => toSelecteArea(index)} >{item.name}</li>
            }))
          }
        </ul>
      </div>

      {
        navActiveIndex === 0 &&
        (<div>
          <div className="flex-top-box">
            <div className="flex-left">
              <h3>
                <span>实时环境监测</span>
                <span>{formatTime(new Date(), 'yyyy-MM-dd hh:mm:ss')}</span>
              </h3>
              <ul>
                <li>
                  <div className="chart-wrap">
                    <div className="ringChart1" id="ringChart1"></div>
                    <div className="text color1">
                      <p>{monitorDetail && monitorDetail.pm2_5}</p>
                      <p>PM25</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="item-icon">
                      <img
                        src="data:image/png;base64,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"
                        width="100%"
                        height="100%"
                      />
                    </div>
                    <div style={{ margin: '0 0 0 16px' }}>
                      <div className="item-content-1">气温</div>
                      <div className="item-content-2">
                        <span>{monitorDetail && monitorDetail.temperature}</span>
                        <span>℃</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="chart-wrap">
                    <div className="ringChart2" id="ringChart2"></div>
                    <div className="text color2">
                      <p>{monitorDetail && monitorDetail.pm10}</p>
                      <p>PM10</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="item-icon">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAApCAYAAAHBrgDTAAAAAXNSR0IArs4c6QAACudJREFUWAmtWHtQVccZ391z7oXLS0CDcEURjUY02kQRE2yqaSRNdUxExxhrnbTpJG3/iHHaaSbN9JFm2snUTNOm7aTTTB8zMZPO2ATUgAopxjr4qoJPRFAEUS4+QnzhBbn3nO3v23P3cICLOJms3rO732t/++33fWcPjHlabuPOFe40UN7xcub+02kuYfBg8sVNq8zEslBL7/Lg5IzdR2Qg4zPGrC4miEDSXD/UwKOfe3LnYs80zjC1qkmOPbRvXV7LVqnYiWUdMrX69C6vrDJLkoHMLhbI/IwlohckGVsbwpxQhL1adx5nHdzbG2yoORFXKrH8vDKVid3GExBETCoPLestHZ+UVtWshO75316Ze7KmVCvc9/k/JIfQ6+HS4C+ImLqjSfqSepgZCDMzET/0NPehdz2XtPnCb8yk8PchMNqAkC8Jv4Cj1BJc5crpVVQ//vgedRBeosLoJdA4allnxjftiLspllzZKjN2NS4ds++gEpgjD/kGG2CJ5SGbiOk1J7pfkzLuKoqIA3mTBCXjya9xrpRoTm3K5Y1qBYRVh+wpzeHJlW0bGOtmY/YeVC7qfOBraqeci9WkYMLaZRrA3k9UB7aUktFmzMRbIPWwGTfffVFIJrOUgN4j9WQrNiclzA8KxvmriZtDrwbSUxD7HHww1P+YJHQaUl5Yb/aWBt8gi8a2tpCZIBsBpYBzPPEjUb+ZkEf8uG3c4T0PTD5T5UCKScQ/w7jqjGUf/q80fBHmT4pMa530zaZ4YnEPIaWirWVUdXOZVhhz4NA7WQjR0f4xCR33L+LRPn5qYsvHtzXf2w9AOLbqYvKNnki38EU3CF/kXsOMLOdmhJlmtPtKcWGqV3HEcaCs40069JVSGlo4vaZBItN+p+fD9TO63p+ueQphoDy0H+c5r3f5OBcxlQnDjDJu9jHDF2VA/OHlucUrtaK3n3L5fQn+waaM7xbxQFnoFcTAG15jyRWtyvm0XToECDNhxHpFs6JGQnRuW/6SI9rwfZ//Uxr+yLdNxNQPueQXNcPpVZgxAbwqzPpjDfFENNuUtn04v70MC/VhwSjUIjDF14ue0mAe1LORgj/TRjkTp9TeyRBCW5mPOYNIUHRE3YWQj0RKHjVfhY3aLmc2HUpg8wUpuZ0CWTddyYDKGWWMbGEJyiG3cZacPtPfwJ/uiy3lcoYMMmuPPoRt7RvoQ3VIDGFVfzZv+ZwhSndLCB7b9e6dZONmSTyFsXV7yrHN53Mbq67H4xPtroxl1dd/Ba5cBvE1cGzahNPbNsUzOMRY2o7zmSnbzsDP0vWp7Os7gtOuD81a8AFnxnLwVk5q31I42OAQY9E+u4uE0muaLOpH19adoxi4OGe+cvaF6Y+Vo5ZV25ItIb63uasTESHSLMzolPCTeTztk0ZKnVakWn5Cop0XKixs9yrGG7vIUrZe/DoEphjcV0CCgpmzEWf5cPqBuzHk6NATLRq1agC/7ubS4CmaSx59mYK066tzHqL5cG3alU0LNE8hSyzv+IQISDPXqdJmzwjB12nB4fqoFd01teu9auI725RsERd8jVZI3dFSQXlnWfKPo2vrZdb+/WF6N2i+tzcEW4UcKyEax8ULVmWJtyxRaKhShBIkqAz5kUKq3lmdoVkLg15jNL6v6z0qYx8BmSxBDME/Tkut6CjWY+pVZVDJrd6HOeNOVssJpyvf88rAtRsgssIkYs/yHPWSp7HFrDW0d4oZZYiIjkVdhOhc1k5s3bxWo2c8qqqJ4zNSiDUuWSbpUqFxqg2ZdcqOW36IRFSQ3TIFmjKGi9cLDpvU7BpSJXl6aytDyhbGeh4Tdt7qzkIkScZ22lL+NcZn4aUT/0ZAHBF6khg1VFbVU8FUA5CI5lAxuoEb87jHiIVTtRZ+KpUPYeBizBo4WlObcgCqLYOkyjukAmZSgdpmrHzz/VdDkaSt5yzs5oLym7LjGKEFqWll5YL+dXYfTl4dcg8Atx0hTFEEvxwC+geB/rBSVl4mg1T/iaLg0EA1zI40j352AU0GLuvwBzyRAdUI2BJ6velQUIHsvGMXnc1dWaMVRjSmBbPr6+/x+btnG37rUtvUR90XsuZTf9fGvEojjSe1HBoVvhGu48KazA3L5kI+2TG9pHIkvcH8Lx0cfVghw97mwmbcwI9buFWocWNaRkJRQ9aj3YNBDDd3A2Q4AU0fVXEuI31760LvDU/zqM/dez6QdeBAA0L6bZpj1293znqUC8M3FQivg15w41r4Zv7ZiheJfzdtRM/BKE+paK9g3FqsPWGY9uvXFhX8Ui+QuefI44JHqpiwmGHIHiNBzg7NKlYvFS0zvnnH7+HF9bCDC4v8sHXiU3Fvllqe+juCS9oSKrRtay+OxQdgEjH0byHspwkEaNcSDGN2hN/+KRfR54nGDVlzpaioBDmsM9i7lhpPbK3Mxo100MVziJgiDAsOn0Z/Ybb8AYKZAVRdQXDCw3WFPJLxScsom0fqEFeTVSwhtpTHfHLdlXmFf4q/zBejDgFHnyLXw/ZxVKB8Molj+vGtp3Lf8ppPrzmbx3nvKdwDEpGNEb9pzLlUPOu4V+bLGA8Al/pxaFokwo6hOvoQxFGDmXNvlWYNqEH4O8E8HPE+eA6ftbIrPT3l3rYH8699UTBTL20qtWW0DNnd6/NZxScznlWVmuy54JK3hJ7AnWO7Q+TnRmfnFFwo5j3eRVOrz8xntlVLiSEM64Iw5Cou2FgpIsLH7eaCh+c07sKmvDojjWfITf6+y9FGxu1JFCbC4I83pq9VFywFLmlz52LbtlWRRDDXhZflzB0c1ClV7fcz6/ZxBD3FIH4KIOINvUoGp6apjFYJIzf6BH+pfdYjV0cCSBVhWtcHRyWLziSAhmE/0pD2vVoe2NaVK3tvn8NRoubxU/jzxPTBwFQ5qWxtA6AJ/YsDDEBQaYAHARLvNl14Y+CJTzzofOT3sx+dnVzSPhzQhfJTs7PrfDtiOIcZtmWkyiyOT79KBP9iUuI+ntezNDjEQPLH514CiD8oYABDPe2QgCkv0jyWtTqDtXcdgE5Gax0k2SVu2rU4ylqUoTbUzS5uWrgT2UWQf4tsIWw24jIj1eUG53ssHjC1U9yLVXTSzYi+gtHoOiFi7xei0D3F4QCzkhj6wAlAB9+tzB4rbHsFNrmCDNn4iuFRst1vAyc9n5aqIzOS85nJlZezh5qkhVmrQ+//5lVUEBECxFe91tUXKporPm1KMR19F7yjGOO4VOAlhjwhuMmddx2gWrcju/uvhkpHPQzD+LMzg5K6tKLDP7JBhtQ9U7GwgLKrdQkm+LENENMBS/wYGAXEUevnqWXeEeGlwXqk71xokdkp+6923g6UdQ54791cktsMU/hOosUdL2jvkEHHNLEIYf+6GGmWGuprvLM/Wg4ttlkaqo2SvuDv4o9zVTR0Gz7g/o7NPecSOGtCWL0pEsTW7sU5V9K2n3kG/v2XSoxYRqogp6wckKlOqVHXJpKLJRBdn2LvZSeRBug4SQY7v27M+M7PCcMAcBpUoLyzCJ75LbayEBmlMtPJPloInnOB0WKUqQ4AWtwLXI1B0xtwMhceczcDeQKIOW4qbdLP5zanfQt/uXdaXHCaeaeeYvOoceJX+OB7BbsVd6pz6sbibsgpQcJ0QAlub0oKpj93jH/j1uD1vjC4wYay9x4ssky5WojoE/D2NO1dx1tunetAudgiTGvz2QlP/gfxGgu8wdac+f8BDYWqySPwuyAAAAAASUVORK5CYII="
                        width="100%"
                        height="100%"
                      />
                    </div>
                    <div style={{ margin: '0 0 0 16px' }}>
                      <div className="item-content-1">湿度</div>
                      <div className="item-content-2">
                        <span>{monitorDetail && monitorDetail.humidity}</span>
                        <span>%</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="chart-wrap">
                    <div className="ringChart3" id="ringChart3"></div>
                    <div className="text color3">
                      <p>{monitorDetail && monitorDetail.noiseDb}</p>
                      <p>噪音db</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="item-icon">
                      <img
                        src="data:image/png;base64,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"
                        width="100%"
                        height="100%"
                      />
                    </div>
                    <div style={{ margin: '0 0 0 16px' }}>
                      <div className="item-content-1">风速</div>
                      <div className="item-content-2">
                        <span>{monitorDetail && monitorDetail.windSpeed}</span>
                        <span>m/s</span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="flex-right">
              <h3>
                <span>最近24小时空气质量</span>
              </h3>
              <div className="air-quality-chart" id="air-quality-chart"></div>
            </div>
          </div>
          <div className="flex-bottom-box">
            <div className="flex-left">
              <h3>
                <span>历史预警</span>
              </h3>
              <div className="search-wrap">
                <Form form={searchForm} layout="inline" onFinish={() => { getTablelList() }}>
                  <Form.Item
                    name="time"
                  // initialValue={moment(new Date().toLocaleDateString())}
                  >
                    <RangePicker />
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" icon={<SearchOutlined />} htmlType="submit">搜索</Button>
                  </Form.Item>
                </Form>
              </div>
              <div className="table-wrap">
                <Table
                  bordered
                  loading={loading}
                  columns={columns}
                  dataSource={tableList}
                  pagination={pagination}
                  onChange={(page) => onPaginationChange(page)}
                />
              </div>
            </div>
            <div className="flex-right">
              <h3>
                <span>最近24小时噪声</span>
              </h3>
              <div className="noise-chart" id="noise-chart"></div>
            </div>
          </div>
        </div>
        )
      }
      {
        navActiveIndex === 1 && <MonitoringDetails  devAddr={deviceList[areaActiveIndex]?.devAddr} devName={deviceList[areaActiveIndex]?.name} />
      }

      {
        navActiveIndex === 2 && <MonitoringDetailsDay  devAddr={deviceList[areaActiveIndex]?.devAddr} devName={deviceList[areaActiveIndex]?.name} />
      }
    </div >
  )
}

export default withRouter(EnvironmentalMonitoring);